export function initDreamUniversityScales() {
  const section = document.querySelector<HTMLElement>(".dream-university__main");
  if (!section) {
    return;
  }

  const scaleItems = [...section.querySelectorAll<HTMLElement>(".dream-university-scale-item")];

  const itemsData = scaleItems.map(item => {
    const bar = item.querySelector<SVGElement>(".progress-bar");
    const valueElement = item.querySelector<HTMLElement>(".dream-university-scale-item__value");

    if (!bar || !valueElement) {
      return null;
    }

    const text = valueElement.textContent?.trim() || "";
    const unitMatch = text.match(/(\D+)$/);
    const unit = unitMatch ? unitMatch[1] : "";
    const maxValue = parseInt(item.getAttribute("data-max") || "100", 10);

    return {
      bar,
      valueElement,
      unit,
      maxValue,
    };
  }).filter(Boolean);

  let ticking = false;
  let isListening = false;

  const update = () => {
    const rect = section.getBoundingClientRect();
    const sectionHeight = rect.height;

    const progress = rect.top < 0 ? Math.min(1, ((-rect.top) + window.innerHeight / 2) / sectionHeight) : 0;

    for (const item of itemsData) {
      if (!item) {
        continue;
      }
      const value = Math.round(progress * item.maxValue);
      item.bar.style.setProperty("--progress", `${progress * 100}`);
      item.valueElement.textContent = `${value}${item.unit}`;
    }

    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !isListening) {
        window.addEventListener("scroll", onScroll, { passive: true });
        isListening = true;
        update();
      } else if (!entry.isIntersecting && isListening) {
        window.removeEventListener("scroll", onScroll);
        isListening = false;
      }
    });
  }, { threshold: 0 });

  observer.observe(section);
}